import { authServerInstance } from "../axiosInstance";

export const getCompanies = async () => {
  try {
    const response = await authServerInstance.get(`/console/companies`);
    return response.data.map((company) => ({
      key: company.comId,
      text: company.comCompany,
      value: company.comId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const companyStartsWith = async (search) => {
  try {
    const response = await authServerInstance.get(`/console/companies`);
    return response.data
      .filter((company) =>
        company.comCompany.toLowerCase().includes(search.toLowerCase())
      )
      .map((company) => ({
        key: company.comId,
        title: company.comCompany,
        value: company.comId,
      }));
  } catch (e) {
    console.error(e);
    return [];
  }
};

